"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDistance;
var formatDistanceShort = {
  lessThanXSeconds: 'Сейчас',
  xSeconds: 'Сейчас',
  halfAMinute: 'Сейчас',
  lessThanXMinutes: '{{count}} м',
  xMinutes: '{{count}} м',
  aboutXHours: '{{count}} ч',
  xHours: '{{count}} ч',
  xDays: '{{count}} д'
};
var formatDistanceFull = {
  lessThanXSeconds: 'Сейчас',
  xSeconds: 'Сейчас',
  halfAMinute: 'Сейчас',
  lessThanXMinutes: '{{count}} мин. назад',
  xMinutes: '{{count}} мин. назад',
  aboutXHours: '{{count}} ч. назад',
  xHours: '{{count}} ч. назад',
  xDays: '{{count}} д. назад'
};
function formatDistance(token, count, options) {
  var _locale$token;
  var locale = options !== null && options !== void 0 && options.addSuffix ? formatDistanceFull : formatDistanceShort;
  var result = (_locale$token = locale[token]) === null || _locale$token === void 0 ? void 0 : _locale$token.replace('{{count}}', count);
  return result;
}